import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { TOKEN } from '../interceptor/auth-interceptor';

export const authGuard: CanActivateFn = async (route, state) => {
    //? Inyección de dependencias
    const auth = inject(AuthService);
    const cookies = inject(CookieService);
    //* Obtenemos el token
    const token = cookies.get(TOKEN);
    //! Si no existe
    if (!token) return restrict(auth);
    //? Verificamos el token con la API y procedemos en función de la respuesta
    const isValidToken = await validateToken(auth, token);
    return isValidToken ? true : restrict(auth);
};

/** @description Valida el token llamando al servicio de autenticación. */
const validateToken = async (auth: AuthService, token: string) => {
    try {
        //? Consultamos a nuestra API Rest
        return await firstValueFrom(auth.checkToken(token));
    } catch {
        //! En caso de error, consideramos el token como inválido
        return false;
    }
};

/** @description Pasamos el servicio, deslogeamos y retornamos false para detener la propagación de la ruta */
const restrict = (auth: AuthService) => {
    auth.logout();
    return false;
};
